import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

const Testimonials = () => {
  const testimonials = [
    {
      name: "Sarah Johnson",
      location: "Mobile, AL",
      text: "I needed to sell my house quickly due to a job relocation. They made me a fair offer and we closed in just 10 days. The whole process was stress-free!",
      rating: 5
    },
    {
      name: "Mike Rodriguez",
      location: "Baldwin County, AL",
      text: "My house needed major repairs that I couldn't afford. They bought it as-is and I didn't have to worry about fixing anything. Great experience!",
      rating: 5
    },
    {
      name: "Jennifer Davis",
      location: "Pensacola, FL",
      text: "After my divorce, I needed to sell the house fast. They were professional, honest, and made the process so easy during a difficult time.",
      rating: 5
    },
    {
      name: "Robert Thompson",
      location: "Gulf Shores, AL",
      text: "I was skeptical at first, but they delivered exactly what they promised. Fair price, quick closing, and no hidden fees. Highly recommend!",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what homeowners are saying about 
            their experience selling to <span className="font-semibold text-red-600">cashx24.com</span>.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 p-8 rounded-xl border border-gray-100"
            >
              {/* Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-red-500 fill-current" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-red-600 font-semibold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-gray-600 text-sm">{testimonial.location}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;